export type FormCreateIssue = {
	success: boolean;
	issueId?: number;
	issueKey?: string | null;
};

export type FormInputData = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	[key: string]: any;
};

// Due to the inability to import the generated enum (JiraCreateIssueByPublicFormRecaptchaType) from gira.d.ts, we duplicate it here
// eslint-disable-next-line no-restricted-syntax
export enum JiraCreateIssueByPublicFormRecaptchaType {
	V2_CHECKBOX = 'V2_CHECKBOX',
	V3_SCORE = 'V3_SCORE',
}
